
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play-to-earn/games/[id]",
      function () {
        return require("private-next-pages/play-to-earn/games/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play-to-earn/games/[id]"])
      });
    }
  